import React, { useState } from 'react';
import './DisclaimerModal.css';

function DisclaimerModal({ onAccept }) {
  const [isChecked, setIsChecked] = useState(false);

  console.log("🎯 Modal disclaimer rendu - visible !");

  const handleAccept = () => {
    if (isChecked) {
      console.log("✅ Disclaimer accepté, navigation...");
      onAccept();
    }
  };

  return (
    <div className="disclaimer-modal-overlay">
      <div className="disclaimer-modal-content">
        <h2>Conditions Générales d'Utilisation de l'Application de Pointage et Information sur la Protection des Données Personnelles HORAE</h2>
        
        <div className="disclaimer-text">
          <p className="disclaimer-intro">
            En cochant cette case, je reconnais avoir lu et compris les conditions ci-dessous, et j'accepte expressément les modalités d'utilisation de l'application de pointage dans le cadre de mon activité professionnelle.
          </p>

          <section>
            <h3>1. Finalité de l'Application</h3>
            <p>L'application a pour unique finalité la gestion du temps de travail. Elle permet :</p>
            <ul>
              <li>de pointer l'heure de début de journée,</li>
              <li>de pointer les pauses (entrée et sortie),</li>
              <li>de pointer l'heure de fin de journée.</li>
            </ul>
          </section>

          <section>
            <h3>2. Collecte de Données Personnelles</h3>
            <p>Dans le cadre de l'utilisation de l'application, les données suivantes sont collectées :</p>
            <ul>
              <li>Identité du salarié (nom, prénom, identifiant interne),</li>
              <li>Horodatage des actions (début, pause, fin),</li>
              <li>Donnée de géolocalisation uniquement au moment précis de chaque pointage.</li>
            </ul>
            <p>Aucune donnée de géolocalisation n'est collectée en dehors des moments où le salarié effectue une action volontaire sur l'application (début de journée, pause, fin de journée).</p>
          </section>

          <section>
            <h3>3. Utilisation des Données</h3>
            <p>Les données collectées sont utilisées exclusivement :</p>
            <ul>
              <li>pour le suivi des horaires de travail,</li>
              <li>pour la gestion administrative des temps de présence et d'absence,</li>
              <li>à des fins de conformité légale et/ou contractuelle.</li>
            </ul>
            <p>Les données ne sont ni partagées ni revendues à des tiers.</p>
          </section>

          <section>
            <h3>4. Respect de la Vie Privée</h3>
            <p>Aucun dispositif de suivi permanent n'est activé.</p>
            <p>La localisation est ponctuelle, strictement liée à une action de pointage, et ne permet en aucun cas un suivi en temps réel du salarié.</p>
          </section>

          <section>
            <h3>5. Durée de Conservation</h3>
            <p>Les données sont conservées pour une durée maximale de 5 ans, conformément à la réglementation applicable en matière de droit du travail et de prescription.</p>
          </section>

          <section>
            <h3>6. Droits du Salarié</h3>
            <p>Conformément au Règlement Général sur la Protection des Données (RGPD), je suis informé(e) que je dispose :</p>
            <ul>
              <li>d'un droit d'accès à mes données,</li>
              <li>d'un droit de rectification ou de suppression,</li>
              <li>d'un droit à la limitation ou à l'opposition au traitement,</li>
              <li>d'un droit d'introduire une réclamation auprès de la CNIL.</li>
            </ul>
            <p>Pour exercer ces droits, je peux adresser une demande à [adresse mail ou postale de l'employeur].</p>
          </section>

          <section>
            <h3>7. Consentement Libre et Éclairé</h3>
            <p>L'utilisation de cette application s'effectue dans un cadre professionnel et s'appuie sur un usage proportionné et transparent des technologies. En cochant cette case, je consens librement à l'utilisation de mes données dans les conditions décrites ci-dessus.</p>
          </section>
        </div>

        <div className="disclaimer-checkbox">
          <label>
            <input
              type="checkbox"
              checked={isChecked}
              onChange={(e) => setIsChecked(e.target.checked)}
            />
            Je reconnais avoir lu et compris les présentes conditions, et j'accepte expressément l'utilisation de l'application dans les modalités décrites ci-dessus.
          </label>
        </div>

        <button
          className={`accept-button ${!isChecked ? 'disabled' : ''}`}
          onClick={handleAccept}
          disabled={!isChecked}
        >
          Accepter et Continuer
        </button>
      </div>
    </div>
  );
}

export default DisclaimerModal; 